import React, { useState, useEffect, useContext } from 'react';
import { Button, FormGroup, Label, Input } from 'reactstrap';
import { AppContext } from '../AppContext';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Card, CardHeader, CardBody, Row, Col } from 'reactstrap';
import { FaFileExcel } from 'react-icons/fa';
import withRoleAccess from './withRoleAccess';

const MySwal = withReactContent(Swal);
const APIURL = process.env.REACT_APP_API_URL;

const ReportesConsolidados = () => {

    const [yearEspae, setYearEspae] = useState('');
    const [termEspae, setTermEspae] = useState('');
    const [yearsEspae, setYearsEspae] = useState([]);

    const [yearGrado, setYearGrado] = useState('');
    const [termGrado, setTermGrado] = useState('');
    const [yearsGrado, setYearsGrado] = useState([]);

    const currentUser = useContext(AppContext).currentUser;

    useEffect(() => {
        if (currentUser && currentUser !== undefined) {
            MySwal.showLoading();
            fetch(`${APIURL}/api/reporte-usuario/periodo-encuesta-espae`)
                .then(response => response.json())
                .then(data => {
                    MySwal.close();
                    setYearsEspae(data);
                    if (data && data.length > 0) {
                        setYearEspae(data[0].anio);
                    }
                })
                .catch(error => console.error('Error al consultar los datos:', error));

            fetch(`${APIURL}/api/reporte-usuario/periodo-encuesta-grado`)
                .then(response => response.json())
                .then(data => {
                    setYearsGrado(data);
                    if (data && data.length > 0) {
                        setYearGrado(data[0].anioAcademico);
                    }
                })
                .catch(error => console.error('Error al consultar los datos:', error));

        }
    }, [currentUser]);

    const handleYearEspaeChange = (e) => {
        setYearEspae(e.target.value);
    };

    const handleTermEspaeChange = (e) => {
        setTermEspae(e.target.value);
    };
    const handleYearGradoChange = (e) => {
        setYearGrado(e.target.value);
    };

    const handleTermGradoChange = (e) => {
        setTermGrado(e.target.value);
    };


    const downloadReportEspae = async (endpoint) => {
        try {
            MySwal.fire({
                title: 'Generando reporte...',
                allowOutsideClick: false,
                didOpen: () => {
                    MySwal.showLoading();
                }
            });

            const requestBody = {
                anio: yearEspae,
                termino: termEspae
            };

            fetch(`${APIURL}${endpoint}`, {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody)
            })
                .then(response => {
                    const contentDisposition = response.headers.get('Content-Disposition');
                    let filename = 'reporte.xlsx';
                    if (contentDisposition) {
                        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        const matches = filenameRegex.exec(contentDisposition);
                        if (matches != null && matches[1]) {
                            filename = matches[1].replace(/['"]/g, '');
                        }
                    }
                    response.blob().then(blob => {
                        MySwal.close();
                        let url = window.URL.createObjectURL(blob);
                        let a = document.createElement('a');
                        a.href = url;
                        a.download = filename;
                        a.click();
                    });
                });
        } catch (error) {
            MySwal.fire('Error', 'Error al generar el reporte', 'error');
        }
    };

    const downloadReportGrado = async (endpoint) => {
        try {
            MySwal.fire({
                title: 'Generando reporte...',
                allowOutsideClick: false,
                didOpen: () => {
                    MySwal.showLoading();
                }
            });

            const requestBody = {
                anio: yearGrado,
                termino: termGrado
            };

            fetch(`${APIURL}${endpoint}`, {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(requestBody)
            })
                .then(response => {
                    const contentDisposition = response.headers.get('Content-Disposition');
                    let filename = 'reporte.xlsx';
                    if (contentDisposition) {
                        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                        const matches = filenameRegex.exec(contentDisposition);
                        if (matches != null && matches[1]) {
                            filename = matches[1].replace(/['"]/g, '');
                        }
                    }
                    response.blob().then(blob => {
                        MySwal.close();
                        let url = window.URL.createObjectURL(blob);
                        let a = document.createElement('a');
                        a.href = url;
                        a.download = filename;
                        a.click();
                    });
                });
        } catch (error) {
            MySwal.fire('Error', 'Error al generar el reporte', 'error');
        }
    };

    return (
        <>
            <h1 id="pageHeader">Reportes consolidados</h1>
            <div style={{ display: "flex", flexDirection : "column", gap: "2rem" }}>
                {currentUser && currentUser.usuario && currentUser.roles
                    && (currentUser.roles.some(r => r.role == "ADMIN") ||
                        currentUser.roles.some(r => ["DECANO", "SUBDECANO", "COORDINADOR_GENERAL", "COORDINADOR_PROGRAMA"].includes(r.role) && r.scope === "ESPAE")) &&
                    <Card>
                        <CardHeader>ESPAE</CardHeader>
                        <CardBody>
                            <Row form>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="yearSelectEspae">Año</Label>
                                        <Input type="select" name="yearEspae" id="yearSelectEspae" onChange={handleYearEspaeChange}>
                                            {yearsEspae.map((y, index) => (
                                                <option key={index} value={y.anio}>{y.anio}</option>
                                            ))}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="termSelectEspae">Término</Label>
                                        <Input type="select" name="termEspae" id="termSelectEspae" onChange={handleTermEspaeChange}>
                                            <option value="">Seleccionar un término</option>
                                            <option value="1S">1S</option>
                                            <option value="2S">2S</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <div style={{ display: "flex", gap: "1rem" }}>
                                        <Button color="primary" onClick={() => downloadReportEspae('/api/reporte-usuario/reporte-servicios-espae')}>
                                            <FaFileExcel /> Servicios
                                        </Button>
                                        <Button color="primary" onClick={() => downloadReportEspae('/api/reporte-usuario/reporte-academico-espae')}>
                                            <FaFileExcel /> Académico
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                }
                {currentUser && currentUser.usuario && currentUser.roles
                    && (currentUser.roles.some(r => r.role == "ADMIN")) &&
                    <Card>
                        <CardHeader>GRADO</CardHeader>
                        <CardBody>
                            <Row form>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="yearSelectGrado">Año</Label>
                                        <Input type="select" name="yearGrado" id="yearSelectGrado" onChange={handleYearGradoChange}>
                                            {yearsGrado.map((y, index) => (
                                                <option key={index} value={y.anioAcademico}>{y.anioAcademico}</option>
                                            ))}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md={6}>
                                    <FormGroup>
                                        <Label for="termSelectGrado">Término</Label>
                                        <Input type="select" name="termGrado" id="termSelectGrado" onChange={handleTermGradoChange}>
                                            <option value="">Seleccionar un término</option>
                                            <option value="0S">0S</option>
                                            <option value="1S">1S</option>
                                            <option value="2S">2S</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <div style={{ display: "flex", gap: "1rem" }}>
                                        <Button color="primary" onClick={() => downloadReportGrado('/api/reporte-usuario/reporte-servicios-grado')}>
                                            <FaFileExcel /> Servicios
                                        </Button>
                                        <Button color="primary" onClick={() => downloadReportGrado('/api/reporte-usuario/reporte-ubep-grado')}>
                                            <FaFileExcel /> UBEP
                                        </Button>
                                        <Button color="primary" onClick={() => downloadReportGrado('/api/reporte-usuario/reporte-practicas')}>
                                            <FaFileExcel /> Prácticas
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>
                }
            </div>
        </>
    );
};

export default withRoleAccess(ReportesConsolidados, ['ADMIN', "DECANO", "SUBDECANO", "COORDINADOR_GENERAL", "COORDINADOR_PROGRAMA"]);